import { UsersRound } from 'lucide-react'
import { useState } from 'react'

import { CARAVAN_TRIP } from '../../config/trip'
import type { AccessGateway } from '../../domain/access'
import { InstallCaravanButton } from '../install/PwaProvider'
import { sessionStore } from './sessionStore'

const PERSON_COLORS = ['sand', 'blue', 'terracotta', 'olive', 'rose', 'indigo'] as const

export function AccessPage({ gateway }: { gateway: AccessGateway }) {
  const [submittingId, setSubmittingId] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)
  const setSession = sessionStore((state) => state.setSession)

  async function selectPerson(memberId: string) {
    setSubmittingId(memberId)
    setError(null)
    try {
      const session = await gateway.selectMember(memberId, navigator.userAgent.slice(0, 60))
      setSession(session)
    } catch {
      setError('Impossible de rejoindre Caravan pour le moment.')
    } finally {
      setSubmittingId(null)
    }
  }

  return (
    <main className="access-page access-page--people">
      <section className="access-story" aria-label="Caravan au Maroc">
        <div className="access-story__shade" />
        <div className="access-story__content">
          <img className="access-story__wordmark" src="/brand/caravan-wordmark.svg" alt="Caravan" />
          <p className="eyebrow eyebrow--light">MAROC · 5–19 SEPTEMBRE</p>
        </div>
      </section>

      <section className="access-panel access-panel--people">
        <div className="access-people-heading">
          <span className="access-people-heading__icon" aria-hidden="true"><UsersRound size={22} /></span>
          <div>
            <h2>Tu es qui ?</h2>
          </div>
        </div>

        <div className="access-people-grid" aria-label="Choisir une personne">
          {CARAVAN_TRIP.participants.map((member, index) => (
            <button
              aria-label={`Ouvrir Caravan avec ${member.displayName}`}
              className={`access-person access-person--${PERSON_COLORS[index] ?? 'sand'}`}
              disabled={submittingId !== null}
              key={member.id}
              onClick={() => void selectPerson(member.id)}
              type="button"
            >
              <span className="access-person__avatar" aria-hidden="true">
                {member.displayName.slice(0, 1)}
              </span>
              <strong>{member.displayName}</strong>
              {submittingId === member.id ? <span>Ouverture…</span> : null}
            </button>
          ))}
        </div>

        {error ? <p className="form-error" role="alert">{error}</p> : null}
        <InstallCaravanButton />
      </section>
    </main>
  )
}
